import { render, staticRenderFns } from "./BasicHeader.vue?vue&type=template&id=94b6139c&"
import script from "./BasicHeader.vue?vue&type=script&lang=js&"
export * from "./BasicHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports